<template>
    <div
        v-if="type == 'donate'"
        class="purchase-item"
        :class="{'purchase-disabled' : isExpired}" >
            <div class="purchase-wrapper">
                <div class="purchase-img">
                    <div class="purchase-redeemdate">{{getRedeemedDate()}}</div>
                    <div class="purchase-img-wrapper">
                        <img class="img-fluid" :src="purchase.fullImageUrl" />
                    </div>
                </div>
                <div class="purchase-info">
                    <div class="purchase-name">{{purchase.name}}</div>
                    <div class="purchase-point">
                        {{getPointMessage()}}
                        <div class="purchase-point-item">
                            <span>{{this.purchase.pointPerUnit | number_format}}</span>
                            <img src="../../../assets/icon/reward_icon_coin.png">
                        </div>
                    </div>
                    <div class="purchase-row"
                    v-if="isShowPrivilegeMessage">
                        <div class="purchase-txt no-icon">
                            <div v-if="isDonateExpired" class="text-underline" v-html="privilegeMessage" @click="redirectToAnnounce()"></div>
                            <div v-else v-html="privilegeMessage"></div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div v-else
        class="purchase-item"
        :class="{'purchase-disabled' : isExpired}">
        <div class="purchase-wrapper">
            <div class="purchase-img"  @click="clickPurchase()">
                <div class="purchase-redeemdate">{{getRedeemedDate()}}</div>
                <div class="purchase-img-wrapper">
                    <img class="img-fluid" :src="purchase.fullImageUrl" />
                </div>
            </div>
            <div class="purchase-info">
                <div @click="clickPurchase()">
                    <div class="purchase-name">{{purchase.name}}</div>
                    <div class="purchase-point">
                        {{getPointMessage()}}
                        <div class="purchase-point-item" v-if="!getCampaignPrivilege">
                            <span>{{showPoint}}</span>
                            <img src="../../../assets/icon/reward_icon_coin.png">
                        </div>
                        <div class="purchase-point-item" v-else>
                            <span>{{ this.purchase.maximumPartialPoints | number_format }}</span>
                            <img src="../../../assets/icon/reward_icon_coin.png">
                            <span> + {{this.purchase.maximumPartialPrice | number_format}} {{ lblPurchase.unit_price }}</span>
                        </div>
                    </div>
                    <div class="purchase-row"
                        v-if="type === 'purchase'">
                        <div class="purchase-icon"></div>
                        <div class="purchase-expired" v-if="!isShowDelivery">
                            {{`${lblPurchase.text_expired} ${purchaseExpired}`}}
                        </div>
                        <div class="purchase-txt"
                            v-if="!isButton && !isShowDelivery"
                            v-html="purchaseMessage"></div>
                        <div class="purchase-txt"
                            v-if="isButton && !isShowDelivery">
                            <div class="purchase-btn" v-html="purchaseMessage"></div>
                        </div>
                    </div>
                    <div class="purchase-row"
                        v-if="type === 'draw'">
                        <div class="purchase-txt no-icon"
                            v-html="purchaseMessage"></div>
                    </div>
                    <div class="purchase-row"
                        v-if="type === 'interface'">
                        <div class="purchase-expired">
                            {{`${lblPurchase.text_expired} ${purchaseExpired}`}}
                        </div>
                        <div class="purchase-txt"
                            v-if="isButton">
                            <div class="purchase-btn" v-html="purchaseMessage"></div>
                        </div>
                    </div>
                    <div class="purchase-row"
                        v-if="isShowDelivery">
                        <div class="purchase-txt no-icon"
                            :class="{'text-shipped' : isShipped}">
                            <img src="../../../assets/icon/ic-check-green.png" v-if="isShipped"/>
                            {{deliveryMessage}}
                        </div>
                    </div>
                </div>
                <div class="purchase-row pt-2"
                    v-if="isShipped" 
                        v-clipboard:copy="purchase.parcelNo"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">
                    <div class="purchase-txt no-icon">
                        {{purchase.parcelNo}} 
                        <img src="@/assets/icon/ic-copy.svg" class="img-fluid" />
                    </div>
                </div>
                <div class="purchase-row"
                    v-if="isShowPrivilegeMessage" @click="clickPurchase()">
                    <div class="purchase-txt no-icon"
                        v-html="privilegeMessage"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//helper
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/locale.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';

export default {
    name: 'PurchaseItem',
    components: '',
    props: {
        lbl: Object,
        index: Number,
        purchase: Object,
        modalController: Object,
    },
    data: function () {
        return {
            campaignType: Vue.CampaignType,
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            lblHistory: this.lbl.history,
            lblPurchase: this.lbl.purchase,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.

            isExpired: false,
            isButton: false,
            purchaseExpired: null,

            isDonateType: false,
            isDonateExpired: false
        };
    },
    created: function () {
        this.initialPurchase();
    },
    mounted: function () {
    },
    computed: {
        getCampaignPrivilege: function () {
            return (this.campaignType.Privilege == this.purchase.type)
        },
        showPoint: function () {
            let point = Util.formatNum(this.purchase.pointPerUnit, 0);
            if(point == 0){
                point = this.lbl.campaign.free;
            }
            return point;
        },
    },
    methods: {
        //event
        redirectToAnnounce: function() {
            this.$router.push('/announce')
        },
        clickPurchase: function () {
            if(!this.isExpired){
                this.$emit('clickPurchase', this.index);
            }
        },
        onCopy: function (e) {
            console.log('You just copied: ', e.text)

            this.modalController.alertModal
                .clearText()
                .setMsg('คัดลอกเรียบร้อย')
                .show();
            
        },
        onError: function (e) {
            console.log('copied error', e);
        },
        //method
        initialPurchase: function () {
            //console.log('pur', this.purchase);
            if (this.purchase.privilegeMessageFormat
                && this.purchase.privilegeMessageFormat.toLowerCase() === 'html')
                this.isShowPrivilegeMessage = false;

            //purchase message.
            this.purchaseExpired = DatetimeHelper.dateShortFormat(this.purchase.voucherExpireDate);

            switch(this.purchase.type) {
                case this.campaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lblPurchase.not_draw1 + (this.lblPurchase.not_draw2 ? ' ' + this.lblPurchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lblPurchase.draw_winner1 + (this.lblPurchase.draw_winner2 ? ' ' + this.lblPurchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage)
                                this.purchaseMessage += "<br />" + this.purchase.adsMessage;
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lblPurchase.draw_not_win1 + (this.lblPurchase.draw_not_win2 ? ' ' + this.lblPurchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case this.campaignType.Buy:
                case this.campaignType.Free:
                case this.campaignType.Deal:
                case this.campaignType.Privilege:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.purchaseMessage = this.lblPurchase.code_expired;
                        this.isExpired = true;
                    } else {
                        this.isActive = true;
                        this.isButton = true;
                        this.purchaseMessage = this.lblPurchase.show_code;
                    }
                    break;
                case this.campaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn &&
                        this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lblPurchase.code_expired;
                        this.isExpired = true;
                        this.isButton = false;
                        this.isShowPrivilegeMessage = false;
                    } else {
                        this.isShowPrivilegeMessage = false;
                        if (this.purchase.website.indexOf('/wondd/truemoney') >= 0 ||
                            this.purchase.website.indexOf('/wondd/garena') >= 0 ||
                            this.purchase.website.indexOf('/starbucks') >= 0)
                        {
                            this.isButton = true;
                        }else{
                            this.isButton = false;
                        }

                        if (this.purchase.pointType == "get")
                            this.purchaseMessage = this.lblPurchase.interface_get;
                        else
                            this.purchaseMessage = this.lblPurchase.interface_use;

                        if(!this.purchaseMessage){
                            this.purchaseMessage = this.lblPurchase.show_code;
                        }
                    }
                    break;
                    case this.campaignType.Donate:
                        this.type = 'donate';
                        this.isShowPrivilegeMessage = true;
                        if (this.privilegeMessage) {
                            var msgArr = this.privilegeMessage.split("|");
                            var textNotExpire = msgArr[0];
                            var textExpire = msgArr[1];
                            // this.purchase.voucherExpireDate = 1651020876; //!for test voucherExpireDate

                            if (this.purchase.currentDate > this.purchase.voucherExpireDate) {
                                // campaign expire
                                this.isDonateExpired = true;
                                this.privilegeMessage = textExpire;
                            } else {
                                // campaign not expire yet
                                this.isDonateExpired = false;
                                this.privilegeMessage = textNotExpire;
                            }

                        }

                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                this.isButton = false;
                if (this.purchase.type === this.campaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }
                
                if(this.purchase.type === this.campaignType.Privilege){
                    //privilege 2.0
                    if (this.purchase.isShipped && this.purchase.parcelNo) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lblPurchase.privilege_shipped;
                    }else if (!this.purchase.isShipped && this.purchase.parcelNo) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lblPurchase.privilege_delivery;
                    } else {
                        this.isShipped = false;
                        this.deliveryMessage = this.lblPurchase.privilege_prepare;
                    }
                }else{
                    if (this.purchase.isShipped) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lblPurchase.shipped;
                    } else {
                        this.isShipped = false;
                        this.deliveryMessage = this.lblPurchase.delivery;
                    }
                }

                
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },
        //utility
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lblHistory.get_point : this.lblHistory.use_point;

            //var pointUnit = this.lblHistory.point + (this.purchase.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            //return pointType + " " + "<span>" + Util.formatNum(this.purchase.pointPerUnit) + "</span>";
            return pointType;
        },
        getRedeemedDate: function () {
            var timestamp = this.purchase.redeemDate;
            var redeemedDate = Moment.unix(timestamp).utc();

            var year = Moment.unix(timestamp).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) {
                var thaiyear = redeemedDate.get('year') + 543;
                //for 2 digits.
                year = thaiyear.toString().substring(2, 4);
            }

            //var monthString = this.lbl.date.month_short[redeemedDate.format('M') - 1];
            var strDate = '';
            strDate = redeemedDate.format('DD') + "/" + redeemedDate.format('MM') + "/" + year;
            strDate += ' ' + redeemedDate.format('HH:mm') + 'น.';

            return strDate;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import '@/style/base/baseText.scss';

.purchase-item {
    @extend %display-flex;
    width: 50%;
    flex: 0 0 50%;
    margin-bottom: 0;

    &.purchase-disabled{
        opacity: 0.6;

        .purchase-wrapper .purchase-info .purchase-point{
            span{
                color: $label-gray;
            }

            img{
                filter: grayscale(100%);
            }
        }
    }

    &:nth-child(2n - 1) {
        padding-right: 10px;
    }

    &:nth-child(2n) {
        padding-left: 10px;
    }

    @include mobile {
        width: 100%;
        flex: 0 0 100%;

        &:nth-child(2n - 1) {
            padding-right: 0;
        }

        &:nth-child(2n) {
            padding-left: 0;
        }
    }

    .purchase-wrapper {
        @extend %display-flex;
        width: 100%;
        padding: 10px 5px 15px;
        border-bottom: 1px solid $border-gray;

        .purchase-img {
            width: 40%;
            flex: 0 0 40%;

            .purchase-img-wrapper {
                position: relative;
                overflow: hidden;
                border: 1px solid $border-gray;
                border-radius: 10px;
                box-shadow: $box-shadow;

                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                &:before {
                    position: relative;
                    content: "";
                    display: block;
                    padding-top: 66.66%;
                }
            }
        }

        .purchase-redeemdate{
            color: $label-gray;
            padding-bottom: 5px;
        }

        .purchase-info {
            width: 60%;
            flex: 0 0 60%;
            padding-top: 25px;
            padding-left: 10px;

            .purchase-expired{
                color: $label-gray;
            }

            .purchase-name{
                @extend %ellipsis-2;
                font-family: $medium;
                font-size: 1.12rem;
                line-height: 1.3;
                color: $bright-gray;
            }
            .purchase-point{
                padding: 5px 0;

                .purchase-point-item{
                    display: inline-block;

                    span{
                        font-family: $medium;
                        font-size: 1.12rem;
                        color: $pink;
                    }

                    img{
                        display: inline-block;
                        border-radius: 50%;
                        border: solid 1px $border-gray;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
                        margin: {
                            top: -5px;
                            left: 8px;
                        }
                    }
                }

            }

            .purchase-txt{
                color: $label-gray;

                .text-underline{
                    text-decoration: underline;
                }

                &.text-shipped{
                    color: $green-dark;

                    img{
                        width: 18px;
                    }
                }

                .purchase-btn{
                    width: max-content;
                    background-color: $deep-blue;
                    color: $white;
                    border-radius: 20px;
                    margin-top: 7px;
                    padding: 2px 20px;
                    text-align: center;
                }
            }
        }
    }
}
</style>
